export default __webpack_public_path__ + "static/media/studyMaterialIcon.6e14a19d.svg";